import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ICountry, EmptyCountry } from "./Country";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect } from "react";
import { Fetch } from "../../../shared/Fetch";
import { JVInput } from "../../../shared/JVInput";

const schema = yup.object({
    country_Name: yup.string().required("Country Name is required*"),
    description: yup.string().nullable()
});

interface Iprops {
    singleData: ICountry,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const Form = (props: Iprops) => {

    const { control, handleSubmit, formState: { errors }, reset } = useForm<ICountry>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    const saveToDB = async (body: ICountry) => {
        const method = props.singleData.country_ID ? "PUT" : "POST";
        const message = props.singleData.country_ID ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch("Country_Mast", method, body, null, props.toast);

        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
        }
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyCountry);
    }

    function onSubmit(data: ICountry) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Country" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVInput required column={1} label="Country Name" control={control} name="country_Name" error={errors.country_Name?.message} />
                <JVInput column={1} label="Description" control={control} name="description" error={errors.description?.message} />
                <div className="col-12 md:col-12">
                    <Button className="field col-12 md:col-6" label="SAVE" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}
